import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import _ from 'lodash';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import { FunnelOverview } from './campaign-overview.types';

interface Props {
  open: boolean;
  loading: boolean;
  funnel: FunnelOverview | null;

  handleClose(): void;

  handleDeleteFunnel(funnelId: string): () => void;
}

const DeleteCampaignDialog: React.FC<Props> = ({ open, loading, funnel, handleClose, handleDeleteFunnel }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'} transitionDuration={0}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteCampaignDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            <Trans i18nKey={'confirmDeleteCampaignDialogContent1'} values={{ name: !_.isNil(funnel) ? funnel.name : '' }}>
              Soll die Kampagne <strong>{!_.isNil(funnel) ? funnel.name : ''}</strong> wirklich gelöscht werden?
            </Trans>
          </Typography>
          <Typography className={classes.text}>{t('confirmDeleteCampaignDialogContent2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton
          text={t('ok')}
          size={'small'}
          border={'rounded'}
          action={!_.isNil(funnel) ? handleDeleteFunnel(funnel._id) : undefined}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      color: theme.palette.primary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default DeleteCampaignDialog;
